import { Box, Flex, FlexProps, Text } from '@chakra-ui/react';
import Tooltip from '~/components/Tooltip';
import { CircleFlagIcon } from '~/components/icons';
import customTheme from '~/styles/theme';

interface Props extends FlexProps {
  countryCode?: string;
  countryName?: string;
  value?: string;
}

export const FlagIconLabel: React.FC<Props> = ({
  countryCode,
  countryName,
  value,
  ...props
}) => {
  return (
    <Flex
      direction="column"
      alignItems="flex-start"
      data-testid={`${countryCode ? `country-${countryCode}` : `empty-state`} `}
      {...props}
    >
      {countryCode ? (
        <CircleFlagIcon boxSize={6} countryCode={countryCode} />
      ) : (
        <Box boxSize={6} borderRadius="full" backgroundColor="neutral.200" />
      )}
      <Tooltip
        label={countryName}
        isTouchFriendly
        placement="top"
        hasArrow={false}
        boxShadow={customTheme.shadows.generic}
        fontSize="md"
      >
        <Text
          marginTop={2}
          fontWeight="medium"
          textTransform="uppercase"
          lineHeight="14px"
          letterSpacing="wide"
          fontSize="lg"
        >
          {countryCode ? countryCode : 'n/a'}
        </Text>
      </Tooltip>
      {!!value && (
        <Text fontSize="md" color="neutral.400" letterSpacing="wide">
          {value}
        </Text>
      )}
    </Flex>
  );
};
